var baseUrl = 'https://docs.sanity.io/help/';
module.exports = function generateHelpUrl(slug) {
  return baseUrl + slug;
};